module.exports = __webpack_public_path__ + "img/upload.f8442d86.png";